export default "__VITE_PUBLIC_ASSET__6e4c3390__"